const websocketActions = {
  APPLY_WEBSOCKET: 'APPLY_WEBSOCKET',
  FETCH_WEBSOCKET: 'FETCH_WEBSOCKET',
  WEBSOCKET_DATASET_CONVERSION_COMPLETE: 'WEBSOCKET_DATASET_CONVERSION_COMPLETE',
  WEBSOCKET_DICTIONARY_CONVERSION_COMPLETE: 'WEBSOCKET_DICTIONARY_CONVERSION_COMPLETE',
};

export default websocketActions;
